import { navigate } from 'gatsby';
import { useEffect } from 'react';

import { AppPathValue, paths } from '@/constants/paths';
import { useProfileContext } from '@/contexts/ProfileContext';
import { OnboardingSteps } from '@/enum/enum';
import { isPublicRoute } from '@/helpers/routeManager';

export const useProtectedPage = () => {
  const { professionalData } = useProfileContext() ?? {};
  const currentPath = (location.pathname ?? '') as AppPathValue;

  useEffect(() => {
    if (isPublicRoute()) return;

    const steps = {
      first: OnboardingSteps.BOARD_REGISTRATION_NUMBER,
      second: OnboardingSteps.EMAIL_CONFIRMATION,
      third: OnboardingSteps.ADD_INTERSECTIONALITY_DATA,
      fourth: OnboardingSteps.POST_REGISTRATION_DATA,
    };
    if (professionalData?.verificationSteps) {
      const currentStep = professionalData.verificationSteps.currentStep;
      const isStatusCompleted = professionalData.verificationSteps.data.isCompleted;

      const isThirdStepCurrent = currentStep === steps.third && !isStatusCompleted;

      if (isThirdStepCurrent) {
        if (!currentPath.startsWith(paths.saude.profissional.cadastrar.diversidade._)) {
          navigate(paths.saude.profissional.cadastrar.diversidade._);
        }
        return;
      }
    }
  }, [professionalData.verificationSteps, currentPath]);
};
